var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_4096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77995 8.86001C7.03327 8.86001 8.85995 7.03333 8.85995 4.78001C8.85995 2.52669 7.03327 0.700012 4.77995 0.700012C2.52663 0.700012 0.699951 2.52669 0.699951 4.78001C0.699951 7.03333 2.52663 8.86001 4.77995 8.86001Z",
    stroke: "#BFC0C0",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6499 7.67999L10.9499 10.98",
    stroke: "#BFC0C0",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_4096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.45,
    height: 11.47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.ca40abb46993a44ad19d13532269e53b.svg";
export { ForwardRef as ReactComponent };